import React, {
  forwardRef,
  useImperativeHandle,
  useState,
  useEffect,
} from "react";
import ProgressSteps from "./progressSteps";
import { useEmployee } from "../../context/EmployeeContext";
import { updateEmployeeDetails } from "../../api/employeesApi";
import { NavLink, Router } from "react-router-dom";

const StepOne = ({ setStepFromUrl }) => {
  const { employeeData, setEmployeeData } = useEmployee();

  const [form, setForm] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    dateOfBirth: "",
    ssn: "",
    residence: {
      street1: "",
      street2: "",
      city: "",
      state: "",
      zipcode: "",
      country: "",
    },
  });

  const [errors, setErrors] = useState({});

  const companyId = "com_affa65d93030f0118b3d6045bdc7c627";
  const employeeId = "emp_55b194e8f530f0118b3d6045bdc7c627";

  useEffect(() => {
    if (employeeData) {
      setForm({
        firstName: employeeData.firstName || "",
        middleName: employeeData.middleName || "",
        lastName: employeeData.lastName || "",
        dateOfBirth: employeeData.dateOfBirth?.split("T")[0] || "",
        ssn: employeeData.ssnLastFour || "",
        residence: {
          street1: employeeData.residence?.street1 || "",
          street2: employeeData.residence?.street2 || "",
          city: employeeData.residence?.city || "",
          state: employeeData.residence?.state || "",
          zipcode: employeeData.residence?.zipcode || "",
          country: employeeData.residence?.country || "",
        },
      });
    }
  }, [employeeData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log("======", { name, value });

    if (name.startsWith("residence.")) {
      const key = name.split(".")[1];
      setForm((prev) => ({
        ...prev,
        residence: { ...prev.residence, [key]: value },
      }));
    } else {
      setForm((prev) => ({ ...prev, [name]: value }));
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!form.firstName.trim()) newErrors.firstName = "First name is required";
    if (!form.lastName.trim()) newErrors.lastName = "Last name is required";
    if (!form.dateOfBirth) newErrors.dateOfBirth = "Date of birth is required";
    // if (!form.ssn || form.ssn.length !== 9) //removing this validtion for now because not getting ssn from the response only getting last four
    //   newErrors.ssn = "SSN must be 9 digits";

    if (!form.residence.street1.trim())
      newErrors.street1 = "Address line 1 is required";
    if (!form.residence.city.trim()) newErrors.city = "City is required";
    if (!form.residence.state.trim()) newErrors.state = "State is required";
    if (!form.residence.zipcode.trim())
      newErrors.zipcode = "Postal code is required";

    return newErrors;
  };

  const handleContinue = async () => {
    const validationErrors = validate();
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length !== 0) return;

    try {
      const payload = {
        firstName: form.firstName,
        middleName: form.middleName,
        lastName: form.lastName,
        email: employeeData?.email,
        ssn: form.ssn,
        defaultNetPaySplit: "",
        dateOfBirth: form.dateOfBirth,
        startDate: employeeData?.startDate,
        terminationDate: "2026-12-01",
        defaultPaymentMethod: employeeData?.defaultPaymentMethod,
        departmentId: employeeData?.department.id,
        primaryWorkplaceId: employeeData?.primaryWorkplaceId,
        workplaces: [employeeData?.workplaces[0].id],
        formW2ElectronicConsent: employeeData?.formW2ElectronicConsent,
        active: employeeData?.active,
        residence: form.residence,
        wage: {
          rate: 32.75,
          period: "Hourly",
          flsaOvertimeExemptionStatus: "NonExempt",
          supplementalTaxMethod: "Aggregate",
          fullTimeHours: 40,
        },
      };
      await updateEmployeeDetails(companyId, employeeId, payload);
      setEmployeeData({ ...employeeData, ...payload });
      setStepFromUrl(2);
      // window.location.href = '/manage-employee/edit-employee?step=2'; // Go to Step 2
    } catch (error) {
      console.error("Failed to update employee:", error);
      alert("Update failed. Please try again.");
    }
  };

  return (
    <div>
      <ProgressSteps currentStep={1} />
      <div>
        <h5 className="mb-2 sub-title">Personal Information</h5>
        <p className="gray-text-for-content mb-4">
          We will need additional details in order to properly onboard you.
        </p>
        <div className="mb-4  row">
          <div className="mb-4 col-4">
            <label className="d-block text-start">First Name</label>
            <div className="position-relative">
              <input
                type="text"
                name="firstName"
                value={form?.firstName || ""}
                onChange={handleChange}
                placeholder="Employee's first name"
                className={`input-base gray-text-for-content `}
              />
              {errors.firstName && (
                <small className="text-danger">{errors.firstName}</small>
              )}
            </div>
          </div>
          <div className="mb-4 col-4">
            <label className="d-block text-start">Middle Name</label>
            <div className="position-relative">
              <input
                type="text"
                name="middleName"
                value={form?.middleName || ""}
                onChange={handleChange}
                placeholder="Employee's middle name, if available"
                className={`input-base gray-text-for-content `}
              />
            </div>
          </div>
          <div className="mb-4 col-4">
            <label className="d-block text-start">last Name</label>
            <div className="position-relative">
              <input
                type="text"
                name="lastName"
                value={form.lastName}
                onChange={handleChange}
                placeholder="Employee's last name"
                className={`input-base gray-text-for-content `}
              />
              {errors.lastName && (
                <small className="text-danger">{errors.lastName}</small>
              )}
            </div>
          </div>
          <div className="mb-4 col-4">
            <label className="d-block text-start">
              Employee's date of birth
            </label>
            <div className="position-relative">
              <input
                type="text"
                name="dateOfBirth"
                value={form.dateOfBirth}
                onChange={handleChange}
                placeholder="Employee's date of birth"
                className={`input-base gray-text-for-content `}
              />
              {errors.dateOfBirth && (
                <small className="text-danger">{errors.dateOfBirth}</small>
              )}
            </div>
          </div>
        </div>
      </div>
      <div>
        <h5 className="mb-2 sub-title">Social Security Number</h5>
        <p className="gray-text-for-content mb-4">
          Employee's TIN (usually their Social Security Number). Must be unique
          across all employees in a company
        </p>
        <div className="mb-4  bg-white rounded row">
          <div className="mb-4 col-4">
            <label className="d-block text-start">SSN</label>
            <div className="position-relative">
              <input
                type="text"
                name="ssn"
                value={form.ssn}
                onChange={handleChange}
                placeholder="Employee's SSN"
                className={`input-base gray-text-for-content`}
              />
              {errors.ssn && (
                <small className="text-danger">{errors.ssn}</small>
              )}
            </div>
          </div>
        </div>
      </div>
      <div>
        <h5 className="mb-2 sub-title">Employee Residence</h5>
        <div className="mb-4  bg-white rounded row">
          <div className="mb-4 col-4">
            <label className="d-block text-start">Address line 1</label>
            <div className="position-relative">
              <input
                type="text"
                name="residence.street1"
                value={form.residence.street1}
                onChange={handleChange}
                placeholder="Enter Address line 1"
                className={`input-base gray-text-for-content`}
              />
              {errors.street1 && (
                <small className="text-danger">{errors.street1}</small>
              )}
            </div>
          </div>
          <div className="mb-4 col-4">
            <label className="d-block text-start">Address line 2</label>
            <div className="position-relative">
              <input
                type="text"
                name="residence.street2"
                value={form.residence.street2}
                onChange={handleChange}
                placeholder="Enter Address line 2"
                className={`input-base gray-text-for-content`}
              />
            </div>
          </div>
        </div>
        <div className="mb-4  bg-white rounded row">
          <div className="mb-4 col-4">
            <label className="d-block text-start">City</label>
            <div className="position-relative">
              <input
                type="text"
                name="residence.city"
                value={form.residence.city}
                onChange={handleChange}
                placeholder="Enter City"
                className={`input-base gray-text-for-content`}
              />
              {errors.city && (
                <small className="text-danger">{errors.city}</small>
              )}
            </div>
          </div>
          <div className="mb-4 col-4">
            <label className="d-block text-start">State</label>
            <div className="position-relative">
              <input
                type="text"
                name="residence.state"
                value={form.residence.state}
                onChange={handleChange}
                placeholder="Enter State"
                className={`input-base gray-text-for-content`}
              />
              {errors.state && (
                <small className="text-danger">{errors.state}</small>
              )}
            </div>
          </div>
          <div className="mb-4 col-4">
            <label className="d-block text-start">Postal code</label>
            <div className="position-relative">
              <input
                type="text"
                name="residence.zipcode"
                value={form.residence.zipcode}
                onChange={handleChange}
                placeholder="Enter postal code"
                className={`input-base gray-text-for-content`}
              />
              {errors.zipcode && (
                <small className="text-danger">{errors.zipcode}</small>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="mt-3">
        <div className="mb-4  ">
          <input className="" type="checkbox" name="routineNumber" value="" />
          <label className="gray-text-for-content m-0">
            I wish to receive paperless W-2 statements and related tax
            information from my employer (the "company").
          </label>
        </div>
        <h6 className="gray-text-for-content mb-3">I acknowledge that:</h6>
        <p className="gray-text-for-content">
          1. If I do not consent by checking the box above, I will receive a
          paper W-2 statement.
        </p>
        <p className="gray-text-for-content">
          2. My consent will be in effect indefinitely or until I withdraw
          consent by reaching out to the company's payroll administrator.
        </p>
        <p className="gray-text-for-content">
          3. I have the option to request a paper W-2 at a later time by sending
          an email to the company's payroll administrator; this will not be
          considered withdrawing my consent to receive paperless statements.
        </p>
        <p className="gray-text-for-content">
          4. I will receive my final W-2 as a paper copy should I no longer be
          employed by the company.
        </p>
      </div>

      <div className="text-center mt-4">
        <NavLink
          type="button"
          to={"/manage-employee"}
          className="cancel-button px-4 mx-2 text-decoration-none"
        >
          Cancel
        </NavLink>

        <button
          type="button"
          onClick={handleContinue}
          className="dark-orange-button px-4"
        >
          Continue
        </button>
      </div>
    </div>
  );
};

export default StepOne;
